var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "main-content": !_vm.taskId } },
    [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: {
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
              },
            }),
            _vm._v(" "),
            !_vm.loading
              ? [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "table",
                        { staticClass: "table table-sm table-hover" },
                        [
                          _c(
                            "tbody",
                            [
                              _c("tr", [
                                _c("td", { staticClass: "bold" }, [
                                  _vm._v("ID"),
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(_vm.task.drug.id))]),
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", { staticClass: "bold" }, [
                                  _vm._v("Название"),
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(_vm.task.drug.title))]),
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", { staticClass: "bold" }, [
                                  _vm._v("Alias"),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.task.drug.en_title)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm._m(0),
                              _vm._v(" "),
                              _vm._m(1),
                              _vm._v(" "),
                              _vm._l(_vm.getSitePrices(), function (price) {
                                return _c("tr", [
                                  _c("td", { attrs: { colspan: "2" } }, [
                                    _vm._v(
                                      "от " +
                                        _vm._s(price.qty) +
                                        " - " +
                                        _vm._s(price.price) +
                                        " руб"
                                    ),
                                  ]),
                                ])
                              }),
                              _vm._v(" "),
                              _vm._m(2),
                              _vm._v(" "),
                              _vm._l(_vm.baseSiteDetails, function (detail) {
                                return _c("tr", [
                                  _c("td", { staticClass: "bold" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.detailsData[detail.detail_id].title
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(detail[detail.type + "_value"])
                                    ),
                                  ]),
                                ])
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("p", [
                        _vm._v("Приоритет: "),
                        _c("span", {
                          class: `priority priority-${_vm.task.drug.priority}`,
                        }),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v("Ключевые слова:")]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.task.drug.keywords))]),
                    ]),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.task
        ? [
            _c(
              "form",
              {
                attrs: { action: "" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.saveRecords.apply(null, arguments)
                  },
                },
              },
              [
                _vm._l(
                  _vm.task.task_data.selected_projects,
                  function (projectId) {
                    return _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-header bg-info" }, [
                        _c("h5", [
                          _vm._v("Создание препарата на "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$AllProjects[projectId].title) +
                                " (" +
                                _vm._s(projectId) +
                                ")"
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.newDrugsData[projectId]
                        ? _c("div", { staticClass: "card-body" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Название препарата"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.newDrugsData[projectId][4].text_value,
                                    expression:
                                      "newDrugsData[projectId][4].text_value",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { required: "", type: "text" },
                                domProps: {
                                  value:
                                    _vm.newDrugsData[projectId][4].text_value,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.newDrugsData[projectId][4],
                                      "text_value",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-4" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _vm._m(3, true),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.newDrugsData[projectId][1]
                                            .text_value,
                                        expression:
                                          "newDrugsData[projectId][1].text_value",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { required: "", type: "text" },
                                    domProps: {
                                      value:
                                        _vm.newDrugsData[projectId][1]
                                          .text_value,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.newDrugsData[projectId][1],
                                          "text_value",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _vm._m(4, true),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.newDrugsData[projectId].prices,
                                      function (price, i) {
                                        return _c(
                                          "div",
                                          { staticClass: "input-group mb-1" },
                                          [
                                            i === 0 ||
                                            _vm.$AllProjects[projectId].settings
                                              ?.use_diff_price
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [_vm._v("От")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: price.qty,
                                                            expression:
                                                              "price.qty",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                          disabled: i === 0,
                                                        },
                                                        domProps: {
                                                          value: price.qty,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              price,
                                                              "qty",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [_vm._v("цена")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.projectsFixedPrices.includes(
                                                    projectId
                                                  ) &&
                                                  Object.values(_vm.egkRates)
                                                    .length
                                                    ? [
                                                        _c("input", {
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "number",
                                                            disabled: "",
                                                          },
                                                          domProps: {
                                                            value:
                                                              (price.price *
                                                                (price.rate ??
                                                                  1)) /
                                                              (price.packing ??
                                                                1),
                                                          },
                                                        }),
                                                      ]
                                                    : [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                price.price,
                                                              expression:
                                                                "price.price ",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "number",
                                                          },
                                                          domProps: {
                                                            value: price.price,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              )
                                                                return
                                                              _vm.$set(
                                                                price,
                                                                "price",
                                                                $event.target
                                                                  .value
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _vm._m(5, true),
                                    _vm._v(" "),
                                    _c("pulse-loader", {
                                      staticClass: "text-center",
                                      attrs: {
                                        loading: _vm.loadingCategories,
                                        color: _vm.$constants.LOADING_COLOR,
                                      },
                                    }),
                                    _vm._v(" "),
                                    !_vm.loadingCategories
                                      ? [
                                          _vm.siteSelects[projectId] &&
                                          _vm.siteSelects[projectId].categories
                                            ? [
                                                _c("multiselect", {
                                                  attrs: {
                                                    name: "category",
                                                    options:
                                                      _vm.siteSelects[projectId]
                                                        .categories,
                                                    placeholder:
                                                      "Выберите категорию",
                                                    "track-by": "name",
                                                    label: "name",
                                                    showLabels: true,
                                                    searchable: true,
                                                    multiple: true,
                                                  },
                                                  on: {
                                                    input: (e) =>
                                                      _vm.selectCategory(
                                                        e,
                                                        projectId
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newDrugsData[
                                                        projectId
                                                      ][5].selectedCategories,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newDrugsData[
                                                          projectId
                                                        ][5],
                                                        "selectedCategories",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newDrugsData[projectId][5].selectedCategories",
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-8" }, [
                                _c(
                                  "table",
                                  { staticClass: "table table-sm table-hover" },
                                  [
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.siteFileds[projectId],
                                        function (value, field) {
                                          return _vm.detailsData[field]
                                            ? _c("tr", [
                                                _c(
                                                  "td",
                                                  { staticClass: "bold" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.detailsData[field]
                                                          .title
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  [
                                                    _vm.detailsData[field]
                                                      .type === "text"
                                                      ? [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .newDrugsData[
                                                                    projectId
                                                                  ][field]
                                                                    .text_value,
                                                                expression:
                                                                  "newDrugsData[projectId][field].text_value",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            attrs: {
                                                              type: "text",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .newDrugsData[
                                                                  projectId
                                                                ][field]
                                                                  .text_value,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                )
                                                                  return
                                                                _vm.$set(
                                                                  _vm
                                                                    .newDrugsData[
                                                                    projectId
                                                                  ][field],
                                                                  "text_value",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.detailsData[field]
                                                      .type === "int"
                                                      ? [
                                                          _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .newDrugsData[
                                                                      projectId
                                                                    ][field]
                                                                      .int_value,
                                                                  expression:
                                                                    "newDrugsData[projectId][field].int_value",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal =
                                                                      Array.prototype.filter
                                                                        .call(
                                                                          $event
                                                                            .target
                                                                            .options,
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            return o.selected
                                                                          }
                                                                        )
                                                                        .map(
                                                                          function (
                                                                            o
                                                                          ) {
                                                                            var val =
                                                                              "_value" in
                                                                              o
                                                                                ? o._value
                                                                                : o.value
                                                                            return val
                                                                          }
                                                                        )
                                                                    _vm.$set(
                                                                      _vm
                                                                        .newDrugsData[
                                                                        projectId
                                                                      ][field],
                                                                      "int_value",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.newDrugsData[
                                                                projectId
                                                              ][field].options,
                                                              function (opt) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      value:
                                                                        opt.id ||
                                                                        opt.title ||
                                                                        opt.name ||
                                                                        opt.value ||
                                                                        opt,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          opt.title ||
                                                                            opt.text ||
                                                                            opt.name ||
                                                                            opt
                                                                        ) +
                                                                        "\n                        "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                              ])
                                            : _vm._e()
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            projectId === 12
                              ? _c(
                                  "div",
                                  { staticClass: "mt-1" },
                                  _vm._l(
                                    _vm.egkRates,
                                    function (er, code, iii) {
                                      return _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              disabled: "",
                                            },
                                            domProps: { value: er.egk_id },
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass: "form-control w-50",
                                            attrs: {
                                              type: "text",
                                              disabled: "",
                                            },
                                            domProps: {
                                              value: er.egk_code.title,
                                            },
                                          }),
                                          _vm._v(" "),
                                          iii === 0
                                            ? [
                                                _c("input", {
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    disabled: "",
                                                    value: "К1",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: er.rate_1,
                                                      expression: "er.rate_1",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: er.rate_1,
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.updateRatePrices,
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        er,
                                                        "rate_1",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("input", {
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    disabled: "",
                                                    value: "К2",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: er.rate_2,
                                                      expression: "er.rate_2",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: er.rate_2,
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.updateRatePrices,
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        er,
                                                        "rate_2",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ])
                  }
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body text-right" },
                    [
                      _c("LoadingButton", {
                        attrs: {
                          title: "Создать препараты",
                          loading: _vm.saveLoading,
                          type: "submit",
                          onClick: () => {},
                          className: "btn btn-success",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "bold" }, [_vm._v("Рубрика")]),
      _vm._v(" "),
      _c("td"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "bold", attrs: { colspan: "2" } }, [
        _vm._v("Цены"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "bold", attrs: { colspan: "2" } }, [
        _vm._v("Список переменных в описании"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "" } }, [
      _c("strong", [_vm._v("ЧПУ препарата")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Ценовые диапазоны")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Категория")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }